
export const featuredEvent = {
  id: 1,
  title: "Nowruz Celebration 2024",
  date: "March 20, 2024",
  time: "6:00 PM - 11:00 PM",
  location: "Kanoon Persian Cultural Center",
  description: "Join us for our annual Nowruz celebration featuring traditional Persian music, dance performances, authentic cuisine, and cultural activities for the whole family.",
  image: "https://public.readdy.ai/ai/img_res/9fb5675fe9b0a4d4b4d17ecd496a8338.jpg",
  price: "Adults: $25, Children: $15",
  category: "Cultural Event"
};

export const upcomingEvents = [
  {
    id: 2,
    title: "Persian Poetry Night",
    date: "April 15, 2024",
    time: "7:00 PM - 9:00 PM",
    location: "Main Hall",
    description: "An evening dedicated to Persian poetry featuring renowned poets and open mic sessions.",
    image: "https://readdy.ai/api/search-image?query=Persian%20poetry%20reading%20event%20in%20elegant%20hall%2C%20people%20sitting%20listening%20to%20poet%20on%20stage%2C%20warm%20ambient%20lighting%2C%20books%20and%20Persian%20calligraphy%20decorations%2C%20cultural%20atmosphere&width=400&height=300&seq=poetry2024&orientation=landscape",
    price: "Free",
    category: "Literature"
  },
  {
    id: 3,
    title: "Persian Cooking Workshop",
    date: "April 28, 2024",
    time: "2:00 PM - 5:00 PM",
    location: "Community Kitchen",
    description: "Learn to cook traditional Persian dishes with our expert chefs. All ingredients provided.",
    image: "https://readdy.ai/api/search-image?query=Persian%20cooking%20class%20with%20chef%20teaching%20traditional%20recipes%2C%20colorful%20spices%20and%20ingredients%20on%20counter%2C%20people%20learning%20to%20cook%2C%20warm%20kitchen%20environment%2C%20Persian%20dishes%20being%20prepared&width=400&height=300&seq=cooking2024&orientation=landscape",
    price: "$45 per person",
    category: "Workshop"
  },
  {
    id: 4,
    title: "Yalda Night Celebration",
    date: "December 21, 2024",
    time: "6:00 PM - 12:00 AM",
    location: "Main Hall",
    description: "Celebrate the longest night of the year with traditional Persian customs, storytelling, and pomegranates.",
    image: "https://readdy.ai/api/search-image?query=Persian%20Yalda%20night%20celebration%20with%20pomegranates%2C%20watermelons%2C%20nuts%2C%20candles%2C%20families%20gathered%20around%20traditional%20setting%2C%20warm%20cozy%20atmosphere%2C%20Persian%20decorations&width=400&height=300&seq=yalda2024&orientation=landscape",
    price: "Adults: $20, Children: $10",
    category: "Cultural Event"
  },
  {
    id: 5,
    title: "Persian Language Classes",
    date: "Every Saturday",
    time: "10:00 AM - 12:00 PM",
    location: "Classroom A",
    description: "Weekly Persian language classes for all levels. Learn to read, write, and speak Persian.",
    image: "https://readdy.ai/api/search-image?query=Persian%20language%20classroom%20with%20teacher%20and%20students%2C%20Persian%20alphabet%20on%20whiteboard%2C%20books%20and%20learning%20materials%2C%20bright%20educational%20environment%2C%20students%20of%20different%20ages&width=400&height=300&seq=language2024&orientation=landscape",
    price: "$80 per month",
    category: "Education"
  },
  {
    id: 6,
    title: "Traditional Music Concert",
    date: "May 18, 2024",
    time: "8:00 PM - 10:00 PM",
    location: "Main Hall",
    description: "Experience the beauty of Persian classical music performed by renowned musicians.",
    image: "https://readdy.ai/api/search-image?query=Persian%20traditional%20music%20concert%20with%20musicians%20playing%20tar%2C%20setar%2C%20and%20tombak%20instruments%20on%20stage%2C%20audience%20enjoying%20performance%2C%20elegant%20concert%20hall%20setting%2C%20warm%20stage%20lighting&width=400&height=300&seq=music2024&orientation=landscape",
    price: "$30 per person",
    category: "Music"
  }
];
